import script from "./CredentialScene.vue?vue&type=script&setup=true&lang=ts"
export * from "./CredentialScene.vue?vue&type=script&setup=true&lang=ts"

import "./CredentialScene.vue?vue&type=style&index=0&id=2218d615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2218d615"]])

export default __exports__